import React from "react";

function MercuryHeader() {
  const headerStyle = {
    background: "linear-gradient(to right, #a86d49, #d69756)",
    borderTop: "2px solid #f2d6b3",
    borderBottom: "2px solid #f2d6b3",
    color: "#fff8dc",
    fontWeight: "600",
    fontSize: "1.1rem",
    textAlign: "center",
    overflow: "hidden",
    position: "relative",
    padding: "8px 0",
    fontFamily: "'Noto Sans Devanagari', 'Poppins', sans-serif",
  };

  const marqueeStyle = {
    display: "inline-block",
    whiteSpace: "nowrap",
    animation: "scroll-left 18s linear infinite",
  };

  const textStyle = {
    textShadow: "0 0 8px #ffd700, 0 0 15px #ffb347",
    letterSpacing: "0.5px",
    animation: "glow 2s ease-in-out infinite alternate",
  };

  return (
    <>
      {/* 🔸 Inline Keyframes */}
      <style>
        {`
          @keyframes scroll-left {
            from { transform: translateX(100%); }
            to { transform: translateX(-100%); }
          }

          @keyframes glow {
            0% { text-shadow: 0 0 6px #ffb347, 0 0 15px #ffd700; }
            50% { text-shadow: 0 0 12px #ffe066, 0 0 25px #ffae42; }
            100% { text-shadow: 0 0 6px #ffb347, 0 0 15px #ffd700; }
          }

          /* 🔸 Mobile Responsiveness */
          @media (max-width: 768px) {
            .mercury-text {
              font-size: 0.95rem !important;
              white-space: nowrap;
            }
          }
        `}
      </style>

      {/* 🔱 Mercury Header */}
      <div style={headerStyle}>
        <div style={marqueeStyle}>
          <span className="mercury-text" style={textStyle}>
             9 अक्टूबर  प्रातः : 9 बजकर ..! 9 मिनट ..! 9 सेकंड पर..!
          </span>
        </div>
      </div>
    </>
  );
}

export default MercuryHeader;
